import styled from "styled-components";

export const Styles = styled.div`
  .btn-insert {
    background: #ffffff;
    border: 1px solid #174a83;
    color: #174a83;
    min-width: 120px;
    height: 32px;
  }

  .dropdown-formular-wrapper {
    position: relative;
    z-index: 10;
    width: 100%;

    .dropdown-formula {
      position: absolute;
      width: 100%;
      top: -16px;
      max-height: 300px;
      overflow: scroll;
    }

    .ant-dropdown-menu-item {
      display: block;
    }

    .wrap-tag {
      font-size: 12px;
      background: #e3e7e8;
      border-radius: 4px;
      padding: 4px;
    }

    .title-tag {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      padding: 4px 8px;
    }

    .description-tag {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      text-align: left;
      margin-top: 4px;
    }
  }
`;

export const StylesRadioItem = styled.div`
  .radio-item {
    margin-bottom: 0;
  }

  .ant-radio-group {
    padding-left: 16px;
    height: 62px;
    display: flex;
    align-items: end;
  }
`;

export const StylesInputFormula = styled.div``;
